import { useTranslations } from 'next-intl';
import { CatIconSuccessFilled } from 'components/blocks-components';
import cx from 'classnames';
import styles from './product-card-fitment-info.module.scss';

export interface ProductCardFitmentInfoProps {
  model: string;
  serialNumber: string;
}

const ProductCardFitmentInfo = ({
  model,
  serialNumber
}: ProductCardFitmentInfoProps) => {
  const t = useTranslations();
  return (
    <div className="d-flex z-2 align-items-start">
      <div className={styles['product-fitment-card-info__icon-container']}>
        <CatIconSuccessFilled
          color="success"
          data-testid="fitment-success-icon"
        />
      </div>
      <p
        className={cx(
          'cat-u-theme-typography-label-sm mb-0 ms-1',
          styles['product-fitment-card-info__label']
        )}
      >
        {t('PART_FACTORY_FIT')} {model} {serialNumber}
      </p>
    </div>
  );
};

export default ProductCardFitmentInfo;
